import React, { useEffect, useState, useRef } from 'react'
import "../css/music-track.css"
import { AnimatePresence, motion, useAnimation } from "framer-motion"
import { useInView } from "react-intersection-observer"
import '../css/music2.css'

import dots from '../assets/dots.svg'
import play from '../assets/play.svg'

const MusicTrack = (props) => {

const [openButton, setOpenButton] = useState(false)

const scrollUp = () => {
    setTimeout(() => 
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    }), 600)
}

const [ yellow, setYellow ] = useState( false )

    const hoverYellow = {
        open: { width: '100%', transition: { ease: [0.9, 0.5, 0, 0.8] } },
        closed: { width: '0%' }
    }


    const hoverYT = {
        open: { y: '0%', transition: { delay: 0.2, ease: [0.9, 0.5, 0, 0.8] } },
        closed: { y: '100%' }
    }

    const hoverApple = {
        open: { y: '0%', transition: { delay: 0.25, ease: [0.9, 0.5, 0, 0.8] } },
        closed: { y: '100%' }
    }

    const hoverSpotify = {
        open: { y: '0%', transition: { delay: 0.3, ease: [0.9, 0.5, 0, 0.8] } },
        closed: { y: '100%' }
    }



const changeVideo = () => {
    props.setVideo(props.title.youtube)
    scrollUp()
}

const clicked = {
    open: { opacity: 1, transition: { duration: 0.3 } },
    closed: { opacity: 0 },
    exit: { opacity: 0, transition: { duration: 0.3 } }
}

let musicRef = useRef()

useEffect(() => {
    let handler = (e) => { 
        if(!musicRef.current.contains(e.target)){
            setOpenButton(false)
        }
    }
    document.addEventListener("mousedown", handler)
}, [openButton])

const { ref, inView } = useInView()
const animation = useAnimation()

useEffect(() => {
    if(inView){
        animation.start({  y: 0, opacity: 1, transition: { ease: "easeOut", duration: 0.3, delay: 0.1 }})
    }
    if(!inView){
        animation.start({ y: 20, opacity: 0, transition: { ease: "easeInOut", duration: 0.3 } })
    }
}, [inView])



  return (
    <>
    <div onMouseEnter={() => setYellow(true)} onMouseLeave={() => setYellow(false)} className='music-entry' style={{ position: 'relative', zIndex: 701 }}>
    
        <motion.div className='mellowyellow' variants={ hoverYellow } initial={ 'closed' } animate={ yellow ? 'open' : 'closed' } style={{ opacity: 1, right: 0, overflow: 'hidden', filter: 'blur(0.5px)', WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)', WebkitBackfaceVisibility: 'hidden', 
     backfaceVisibility: 'hidden', willChange: 'filter' }}>
            <div></div>
            <motion.div>
                <img src={ play } width='100%' />
            </motion.div>
            <div className='media-select' style={{ textTransform: 'uppercase' }}>
                <motion.a className='cursor-over' whileHover={{ color: '#00000055' }} href={props.title.spotify} target='_blank' animate={ yellow ? 'open' : 'closed' } variants={ hoverSpotify }>SPOTIFY</motion.a>
                <motion.a className='cursor-over' whileHover={{ color: '#00000055' }} href={props.title.apple} target='_blank' animate={ yellow ? 'open' : 'closed' } variants={ hoverApple }>APPLE &nbsp;&nbsp;&nbsp;</motion.a> 
                {props.title.youtube ? <motion.div className='cursor-over' onClick={changeVideo} whileHover={{ color: '#00000055' }} animate={ yellow ? 'open' : 'closed' } variants={ hoverYT }>YOUTUBE &nbsp;&nbsp;&nbsp; </motion.div> : <div></div>}
            </div>
            <div></div>
        </motion.div>

    <div className='music-cover-image'>
        <img src={props.title.imageUrl} style={{ width: '100%', height: '100%', zIndex: 702, position: 'relative' }} />
    </div>
    <div className='music-bigger-text' style={{ filter: 'blur(0.5px)', WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)', WebkitBackfaceVisibility: 'hidden', 
     backfaceVisibility: 'hidden', willChange: 'filter' }}>
        <div style={{ position: 'relative', textTransform: 'uppercase' }}>
            <div className='release-type' style={{ position: 'absolute' }}><h5>{ props.category === 1 ? 'SINGLE' : props.category === 2 ? 'REMIX' : props.category === 0 ? 'ALBUM' : ''  }</h5></div>
            { props.title.artist }</div>
        <div style={{ textTransform: 'uppercase' }}>{ props.title.title }</div>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={ dots } style={{ width: '20px' }} />
    </div>
</div>

    {/* <motion.div ref={ ref } animate={ animation }>
        <motion.div layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="music-track-container" style={{ zIndex: 70 }}>
            <div className='music-track-image'>
                <img src={props.title.imageUrl} width={ "100%" } />
            </div>
            <div className='music-track-center'>
                <div className="music-track-artist">{ props.title.artist }</div>
                <div className="music-track-name"> { props.title.title }</div>
            </div>
            <div>
                <div className='music-track-arrow'>
                    <svg width="22" height="22">
                        <line x1="18" y1="2" x2="2" y2="18" stroke="white" />
                        <line x1="18" y1="2" x2="18" y2="18" stroke="white" />
                        <line x1="2" y1="2" x2="18" y2="2" stroke="white" />
                    </svg>
                </div>
                <div className='music-track-button-container'>
                    {props.title.youtube ? <div className="music-track-button" onClick={changeVideo}>YouTube<motion.div whileHover={{ opacity: 1}} transition={{ duration: 0.3 }} className="music-track-overlay"></motion.div></div> : <div className="empty-square" />}
                <a style={{ textDecoration: "none" }} className="music-track-button" href={props.title.spotify} target="_blank">Spotify<motion.div whileHover={{ opacity: 1}} transition={{ duration: 0.3 }} className="music-track-overlay"></motion.div></a>
                <a style={{ textDecoration: "none" }} className="music-track-button" href={props.title.apple} target="_blank">Apple<br />Music<motion.div whileHover={{ opacity: 1}} transition={{ duration: 0.3 }} className="music-track-overlay"></motion.div></a>
                </div>
            </div>
        </motion.div>
    </motion.div> */}
    
    {/* <motion.div onClick={() => setOpenButton(true) } className="mobile-button"></motion.div>
    

        <motion.div className='mobile-shell' ref={musicRef} > 
            <AnimatePresence>
            { openButton && (
                    <motion.div variants={ clicked } initial={{ opacity: 0 }} animate={ openButton ? "open" : "closed"} className="mobile-cover-overlay">
                        <motion.div className="mobile1"><motion.div  className="mobile-inner"></motion.div></motion.div>
                    </motion.div>
                        )}
            </AnimatePresence>
            <AnimatePresence>
            { openButton && (
                <motion.div variants={ clicked } initial={{ opacity: 0 }} animate={ openButton ? "open" : "closed"} className="mobile-button-container"><div className='mobile2'></div>
                {props.title.youtube ? <div className="mobile3" onClick={changeVideo}>YouTube</div> : <div className="empty-square" />}
                <a style={{ textDecoration: "none" }} href={props.title.spotify} target="_blank" className='mobile3'>Spotify</a>
                <a style={{ textDecoration: "none" }} href={props.title.apple} target="_blank" className='mobile3'>Apple<br />Music</a></motion.div> 
            )}
            </AnimatePresence>
        </motion.div> */}
    </>
  )
}

export default MusicTrack